import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../esri-loader-util';
import { InputConverter } from '../../inputConverter';
import { LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
import ExtentConfiguration, { ExtentConfigurationArrayConverter } from './extent.config';
var Extent;
var ExtentComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExtentComponent, _super);
    function ExtentComponent(_vcr, LoggingService, UserSettingsService, authService) {
        var _this = _super.call(this, _vcr) || this;
        _this.LoggingService = LoggingService;
        _this.UserSettingsService = UserSettingsService;
        _this.authService = authService;
        _this.extentChanged = new EventEmitter();
        _this.showLabels = false;
        _this.vertical = true;
        _this.animateChange = true;
        _this.includeUserDefault = true;
        _this.extentConfigs = [];
        _this.executeExtentChange = function (extentConfig) {
            _this.changeMapExtent(extentConfig);
        };
        _this.authService.GetCurrentUser().subscribe(function (user) {
            if (user && user.id) {
                _this.userEmail = user.emailAddress;
            }
        });
        return _this;
    }
    ExtentComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.setupUserDefault();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExtentComponent.prototype.addExtentConfiguration = function (extentConfig) {
        this.extentConfigs.push(new ExtentConfiguration(extentConfig));
    };
    ExtentComponent.prototype.setupUserDefault = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userSettingsComponent, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.includeUserDefault) return [3 /*break*/, 4];
                        this.setDefaultExtent(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getClosestAncestor('mc-user-settings')];
                    case 2:
                        userSettingsComponent = _a.sent();
                        userSettingsComponent.activeChange.subscribe(function (active) {
                            if (!active) {
                                _this.setDefaultExtent();
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExtentComponent.prototype.setDefaultExtent = function (firstLoad) {
        var _this = this;
        if (firstLoad === void 0) { firstLoad = false; }
        this.UserSettingsService.GetSettingValue('userSettings', this.appName, this.userEmail).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var existingConfig, defaultExtent, extentConfig;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Extent];
                    case 1:
                        Extent = _a.sent();
                        existingConfig = this.extentConfigs.find(function (extentConfig) { return extentConfig.label === 'Default Extent'; });
                        if (result && result.extent && result.extent.default) {
                            defaultExtent = Extent.fromJSON(result.extent.default);
                            if (existingConfig) {
                                existingConfig.extent = defaultExtent;
                            }
                            else {
                                extentConfig = new ExtentConfiguration({
                                    extent: defaultExtent,
                                    icon: 'home',
                                    label: 'Default Extent'
                                });
                                this.extentConfigs.unshift(extentConfig);
                                if (firstLoad) {
                                    this.changeMapExtent(extentConfig);
                                }
                            }
                        }
                        else if (existingConfig) {
                            this.extentConfigs.splice(this.extentConfigs.indexOf(existingConfig), 1);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ExtentComponent.prototype.changeMapExtent = function (extentConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var extent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(extentConfig.extentType === 'async-func')) return [3 /*break*/, 2];
                        return [4 /*yield*/, extentConfig.extent(this.mapViewRef)];
                    case 1:
                        extent = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (extentConfig.extentType === 'func') {
                            extent = extentConfig.extent(this.mapViewRef);
                        }
                        else {
                            extent = extentConfig.extent;
                        }
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.mapViewRef.goTo(extent, { animate: this.animateChange })];
                    case 4:
                        _a.sent();
                        this.extentChanged.emit(this.mapViewRef.extent);
                        this.LoggingService.Log('Extent Changed', this.mapViewRef.extent, LogLevel.Trace);
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(ExtentConfigurationArrayConverter),
        tslib_1.__metadata("design:type", Array)
    ], ExtentComponent.prototype, "extentConfigs", void 0);
    return ExtentComponent;
}(BaseComponent));
export { ExtentComponent };
